import { identity as u } from "./continuous.js";
import { initInterpolator as a } from "./init.js";
import l from "../../d3-array/src/ascending.js";
import f from "../../d3-array/src/quantile.js";
import { bisectRight as m } from "../../d3-array/src/bisect.js";
function p() {
  var n = [], e = u;
  function r(t) {
    if (t != null && !isNaN(t = +t)) return e((m(n, t, 1) - 1) / (n.length - 1));
  }
  return r.domain = function(t) {
    if (!arguments.length) return n.slice();
    n = [];
    for (let i of t) i != null && !isNaN(i = +i) && n.push(i);
    return n.sort(l), r;
  }, r.interpolator = function(t) {
    return arguments.length ? (e = t, r) : e;
  }, r.range = function() {
    return n.map((t, i) => e(i / (n.length - 1)));
  }, r.quantiles = function(t) {
    return Array.from({ length: t + 1 }, (i, o) => f(n, o / t));
  }, r.copy = function() {
    return p(e).domain(n);
  }, a.apply(r, arguments);
}
export {
  p as default
};
